import { fetchConToken } from '../utils/fetch.ts';

// Crear nueva solicitud de reembolso
export const crearReembolso = async (reembolsoData) => {
  try {
    const resp = await fetchConToken("giras/reembolsos/crear-reembolso", reembolsoData, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al crear reembolso:', error);
    return { error: true, msg: "Error al crear solicitud de reembolso" };
  }
};

// Obtener reembolsos de un alumno para una gira
export const obtenerReembolsosAlumnoGira = async (alumnoId, giraId) => {
  try {
    const resp = await fetchConToken(`giras/reembolsos/${alumnoId}/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener reembolsos:', error);
    return { error: true, msg: "Error al obtener reembolsos" };
  }
};

// Obtener detalle de un reembolso específico
export const obtenerReembolsoDetalle = async (reembolsoId) => {
  try {
    const resp = await fetchConToken(`giras/reembolso/${reembolsoId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener detalle de reembolso:', error);
    return { error: true, msg: "Error al obtener detalle del reembolso" };
  }
};

// Validar período de reembolso para una gira
export const validarPeriodoReembolso = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/reembolsos/validar-periodo/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al validar período:', error);
    return { error: true, msg: "Error al validar período de reembolso" };
  }
};

// Obtener historial de cambios de un reembolso
export const obtenerHistorialReembolso = async (reembolsoId) => {
  try {
    const resp = await fetchConToken(`giras/reembolsos/historial/${reembolsoId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener historial:', error);
    return { error: true, msg: "Error al obtener historial del reembolso" };
  }
};

// Obtener todos los reembolsos de una gira (para admin)
export const obtenerReembolsosGira = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/reembolsos/gira/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener reembolsos de gira:', error);
    return { error: true, msg: "Error al obtener reembolsos" };
  }
};

// Aprobar reembolso
export const aprobarReembolso = async (reembolsoId, data) => {
  try {
    const resp = await fetchConToken(`giras/reembolsos/aprobar/${reembolsoId}`, data, "PUT");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al aprobar reembolso:', error);
    return { error: true, msg: "Error al aprobar reembolso" };
  }
};

// Rechazar reembolso
export const rechazarReembolso = async (reembolsoId, data) => {
  try {
    const resp = await fetchConToken(`giras/reembolsos/rechazar/${reembolsoId}`, data, "PUT");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al rechazar reembolso:', error);
    return { error: true, msg: "Error al rechazar reembolso" };
  }
};
